// Enum keys sent to backend (backend validates via FileTypeEnum[key])
export enum FileTypeEnum {
  Dispense = 'Dispense', // Epic-WAM
  Drx = 'Drx',
  Pioneer = 'Pioneer',
}

// Display labels for the file type dropdown
export const FILE_TYPE_LABELS: Record<FileTypeEnum, string> = {
  [FileTypeEnum.Dispense]: 'Epic',
  [FileTypeEnum.Drx]: 'DRx',
  [FileTypeEnum.Pioneer]: 'Pioneer',
};

// Enum keys sent to backend (backend validates via FileFrequencyEnum[key])
export enum FileFrequencyEnum {
  Daily = 'Daily',
  Monthly = 'Monthly',
  Weekly = 'Weekly',
}

// Display labels for the frequency dropdown
export const FILE_FREQUENCY_LABELS: Record<FileFrequencyEnum, string> = {
  [FileFrequencyEnum.Daily]: 'Daily',
  [FileFrequencyEnum.Monthly]: 'Monthly',
  [FileFrequencyEnum.Weekly]: 'Weekly',
};

// Backend status values from FileImportTrackerStatusEnum
export enum FileTrackerStatus {
  Pending = 'pending',
  Validated = 'validated',
  Completed = 'completed',
  Failed = 'failed',
}

export const FILE_STATUS_LABELS: Record<FileTrackerStatus, string> = {
  [FileTrackerStatus.Pending]: 'Pending',
  [FileTrackerStatus.Validated]: 'Validated',
  [FileTrackerStatus.Completed]: 'Completed',
  [FileTrackerStatus.Failed]: 'Failed',
};

// Matches backend IFileImportFileTracker (snake_case from DB)
export interface IFileImportFileTracker {
  id: number;
  customer_id: number;
  file_type: string;
  frequency: string;
  file_name: string;
  s3_path: string;
  s3_bucket: string;
  status: string;
  total_rows: number | null;
  success_count: number | null;
  error_count: number | null;
  uploaded_by: number | null;
  created_ts: string;
  updated_ts: string;
}

// Response from POST /app-manager/file-import/upload
export interface IPresignedUploadResponse {
  url: string;
  fields: Record<string, string>;
  s3Key: string;
  id: number;
}

// Request body for POST /app-manager/file-import/upload
export interface ICreatePresignedUploadPayload {
  file_name: string;
  customer_id: number;
  file_type: FileTypeEnum;
  frequency: FileFrequencyEnum;
}
